const updates = [
  {
    date: '07-30',
    tag: '新片上线',
    title: '《流浪地球3》高清版现已上线，4K画质震撼呈现',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    date: '07-29',
    tag: '剧集更新',
    title: '《大奉打更人》第28集更新，精彩剧情持续热播中',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    date: '07-28',
    tag: '专题推荐',
    title: '暑期档科幻电影专题上线，12部高分科幻一次看够',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    date: '07-27',
    tag: '新片上线',
    title: '《封神第二部》全网首发，史诗级神话巨制不容错过',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    date: '07-26',
    tag: '系统优化',
    title: '播放引擎升级完成，移动端加载速度再提升40%',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    date: '07-25',
    tag: '剧集更新',
    title: '《庆余年3》最新剧集已同步，会员专享提前看',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    date: '07-24',
    tag: '新片上线',
    title: '奥斯卡获奖影片《奥本海默》加长版高清上线',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    date: '07-23',
    tag: '功能更新',
    title: '新增智能推荐算法，根据观影记录为你精准匹配好片',
    tagColor: 'bg-primary-100 text-primary-700',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            实时动态
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            最新快讯
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            影片上架、剧集更新、功能升级 —— 一手资讯尽在掌握
          </p>
        </div>

        <div className="max-w-[800px] mx-auto">
          <div className="relative pl-8 md:pl-10">
            <div className="absolute left-0 top-2 bottom-2 w-px bg-background-300"></div>
            <div className="flex flex-col gap-5">
              {updates.map((item, idx) => (
                <div key={idx} className="relative">
                  <span className="absolute -left-[36px] md:-left-[44px] top-1.5 w-3.5 h-3.5 rounded-full bg-primary-500 border-2 border-background-100"></span>
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                    <span className="text-xs text-foreground-400 font-mono whitespace-nowrap">{item.date}</span>
                    <span className={`inline-block px-2.5 py-0.5 rounded-md text-xs font-medium whitespace-nowrap ${item.tagColor}`}>
                      {item.tag}
                    </span>
                    <p className="text-sm text-foreground-700 leading-relaxed">{item.title}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}